/**
 * One home for browser-push constants and labels (plans/admin_web_push_notifications.md 5.1, 6).
 *
 * Topic keys are the UPPERCASE backend enum (`PushTopic`); a topic the backend adds that is missing here is shown under its
 * own key rather than hidden.
 */

export const PUSH_API_BASE = '/api/admin/push'

// The worker's messages to open tabs (src/sw.js sends them).
export const SW_MESSAGE_ALERT_PUSHED = 'operator-alert-pushed'
export const SW_MESSAGE_SUBSCRIPTION_CHANGED = 'push-subscription-changed'
// A notification click: the worker focuses an open tab and sends `{ type, url }`; the PAGE (main.js, so every page including
// the login page) does an in-app Inertia visit, with no reload and no unsaved-changes guard. The worker waits for nothing:
// a window opened after a wait may be refused by the browser.
export const SW_MESSAGE_OPEN_NOTIFICATIONS = 'open-notifications'
// The only page a notification ever opens.
export const PUSH_OPEN_PATH = '/notifications'

// `navigator.serviceWorker.ready` never resolves when the worker failed to register; turning notifications on gives up
// after this long and says so instead of leaving the button disabled for ever.
// The first heal after a page load (re-registering this device) is retried on failure with exponential backoff, at most
// this many attempts in all.
export const HEAL_MAX_ATTEMPTS = 3
export const HEAL_RETRY_BASE_MS = 2000

export const SW_READY_TIMEOUT_MS = 5000
export const PUSH_TOPICS_SAVE_FAILED =
  'Could not save your notification choices. They were left as they were.'

// Leaving the page for /logout waits at most this long for the server to forget this browser.
export const LOGOUT_UNSUBSCRIBE_TIMEOUT_MS = 2500

export const PUSH_TOPIC_LABELS = {
  CRITICAL_ALERTS: 'Critical alerts (a line down, calls cannot be made or answered)',
  BOOKING_CREATED: 'A meeting was booked',
  CALLBACK_REQUESTED: 'A caller asked for a callback',
  MESSAGE_LEFT: 'A caller left a message for your team',
}

// What the card says for each state; `on` is the only green.
export const PUSH_STATE_TEXT = {
  loading: 'Checking notification support',
  unsupported: 'This browser cannot receive push notifications.',
  needsHomeScreen:
    'On iPhone and iPad, add this site to your Home Screen first (Share, then Add to Home Screen), then open it from there to turn notifications on.',
  disabled: 'Browser notifications are not enabled on this server.',
  misconfigured:
    'Browser notifications are switched on but not configured correctly on this server. Ask an administrator to check the server log.',
  denied:
    'Notifications are blocked for this site in your browser settings. Allow them there, then reload this page.',
  off: 'Notifications are off on this device.',
  on: 'Notifications are on for this device.',
  failed: 'Could not change the notification setting. Try again.',
}
